export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm'
export const DEFAULT_DATE_FORMAT_WITHOUT_TIME = 'DD/MM/YYYY'

export const BEGINNING_OF_TIME = '01/01/1970 08:00'

export const DEFAULT_DATE_FORMAT_WITH_ZONE = `${DEFAULT_DATE_FORMAT} Z`
